import { PersonalityType } from "../../__generated__/types";

export const CARD_BORDER = "1px solid #E6E8EE";
export const CARD_RADIUS = "18px";
export const SECTION_BORDER = "1px solid #E3E7EF";
export const SECTION_BG = "var(--Primary-Light, #F7F9FB)";
export const ACCENT_COLOR = "#E11D7C";
export const CHIP_COLOR = "#4F46E5";
export const HERO_HEIGHT_XS = 220;
export const HERO_HEIGHT_MD = 220;
export const FIRST_TAB_TITLE_SIZE = { xs: "18px", md: "31.25px" };
export const AVATAR_SIZE = 120;
export const AVATAR_OVERLAP = AVATAR_SIZE / 2;
export const MATCHING_RING_RADIUS = 46;
export const MATCHING_RING_STROKE = 18;
export const MATCHING_RING_CIRCUMFERENCE =
  2 * Math.PI * MATCHING_RING_RADIUS;
export const PROFILE_TABS = [
  "Personality",
  "Design Style",
  "Project",
  "Preference",
  "Notes",
];
export const WORKING_TABS = [
  "Communication",
  "Collaboration",
  "Connection",
] as const;
export type WorkingTab = (typeof WORKING_TABS)[number];
export const DESIGNER_INTERACTION_STYLE = "Extrovert Blue Gold";
export const DESIGNER_PERSONALITY_EXAMPLE = PersonalityType.ExtrovertBlueGold;
export const DESIGN_STYLE_IMAGE_COUNT = 3;
